import API from './API';
import errorHandler from '../helpers/errorHandler';

export default {
  getInvestors({ query = undefined, limit = 10, page = 1, all = false }) {
    let queryPromise;
    if (query) {
      queryPromise = API.get(`/v1/investors?q=${query}&limit=${limit}&page=${page}`);
    } else if (all) {
      queryPromise = API.get('/v1/investors?all=true');
    } else {
      queryPromise = API.get(`/v1/investors?limit=${limit}&page=${page}`);
    }
    return queryPromise
      .then((response) => {
        return response.data;
      })
      .catch(errorHandler.handleAPIError);
  },
  getInvestor(id) {
    return API.get(`/v1/investors/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch(errorHandler.handleAPIError);
  },
  updateInvestor(id, data) {
    return API.put(`/v1/investors/${id}`, data)
      .then((response) => {
        return response.data;
      })
      .catch(errorHandler.handleAPIError);
  },
  deleteInvestor(id, data) {
    return API.delete(`/v1/investors/${id}`, data)
      .then((response) => {
        return response.data;
      })
      .catch(errorHandler.handleAPIError);
  },
  addInvestor(ionvestorData) {
    return API.post('/v1/investors', ionvestorData)
      .then((response) => {
        return response.data;
      })
      .catch(errorHandler.handleAPIError);
  },
};
